import React from 'react';

const DirectoryPlansPage = () => {
  const plans = [
    { title: 'Plan Premium – 1 Mes', period: '1 mes' },
    { title: 'Plan Premium – 3 Meses', period: '3 meses' },
    { title: 'Plan Premium – 12 Meses', period: '12 meses' }
  ];

  return (
    <div className="lawyer-page">
      <section className="membership-section">
        <div className="container">
          <div className="section-header">
            <h1 className="section-title">Planes del Directorio</h1>
            <p className="section-description">
              Selecciona el plan Premium que mejor se adapte a tu empresa o práctica.
            </p>
          </div>

          <div className="plans-container" style={{ marginTop: 24 }}>
            {plans.map((plan) => (
              <div key={plan.period} className="plan-card premium-plan">
                <div className="plan-header">
                  <h3 className="plan-title">{plan.title}</h3>
                  <div className="plan-price">
                    <span className="price-amount">Por definir</span>
                    <span className="price-period">/{plan.period}</span>
                  </div>
                </div>

                <div className="plan-features">
                  <h4 className="features-title">Incluye:</h4>
                  <ul className="features-list">
                    <li className="feature-item">Perfil profesional (logo, biografía, fotos)</li>
                    <li className="feature-item">Categorías y estados de servicio</li>
                    <li className="feature-item">Contacto directo (WhatsApp / botones)</li>
                    <li className="feature-item">Sello verificado (según validación)</li>
                  </ul>
                </div>

                <div className="plan-action">
                  <button className="btn btn-primary plan-btn" type="button" disabled>
                    Seleccionar plan (próximamente)
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default DirectoryPlansPage;
